import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../services/authentication/authService";
import toast from "../utils/toast";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [form, setForm] = useState({ userId: "", password: "" });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validate = () => {
    const e = {};
    if (!form.userId.trim()) e.userId = "User ID is required.";
    if (!form.password) e.password = "Password is required.";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const doLogin = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      const res = await loginUser(form.userId.trim(), form.password);
      if (res.statuscode !== 1) {
        toast.error(res.msg);
        return;
      }
      login(res.data);
      toast.success(res.msg);
      navigate("/dashboard", { replace: true });
    } catch (err) {
      toast.error(
        err.response?.data?.msg || "Something went wrong. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="auth-wrap screen active" id="screen-login">
        <form className="auth-card" onSubmit={doLogin} noValidate>
          <div className="auth-logo">
            <div className="mark">
              <svg width={20} height={20} viewBox="0 0 24 24" fill="none">
                <path
                  d="M4 17V7l8-4 8 4v10l-8 4-8-4z"
                  stroke="#fff"
                  strokeWidth="1.8"
                  strokeLinejoin="round"
                />
                <path
                  d="M4 7l8 4 8-4M12 11v10"
                  stroke="#fff"
                  strokeWidth="1.8"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="at">
              CorpBills<span>Corporate portal sign in</span>
            </div>
          </div>
          <h2>Welcome back</h2>
          <p className="as">
            Sign in with your corporate credentials to continue.
          </p>
          <div className="field">
            <label>Corporate / user ID</label>
            <input
              type="text"
              name="userId"
              value={form.userId}
              onChange={handleChange}
              placeholder="Enter user ID or mobile"
              disabled={loading}
              style={errors.userId ? { borderColor: "#dc2626" } : {}}
            />
            {errors.userId && (
              <span style={{ color: "#dc2626", fontSize: 11 }}>
                {errors.userId}
              </span>
            )}
          </div>
          <div className="field">
            <label>Password</label>
            <div style={{ position: "relative" }}>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={form.password}
                onChange={handleChange}
                placeholder="Enter password"
                disabled={loading}
                style={{
                  paddingRight: 42,
                  ...(errors.password ? { borderColor: "#dc2626" } : {}),
                }}
              />
              <button
                type="button"
                onClick={() => setShowPassword((p) => !p)}
                aria-label={showPassword ? "Hide password" : "Show password"}
                style={{
                  position: "absolute",
                  right: 12,
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  padding: 0,
                  cursor: "pointer",
                  color: "var(--text-dim)",
                  display: "flex",
                }}
              >
                <svg width={18} height={18} viewBox="0 0 24 24" fill="none">
                  <path
                    d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12z"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinejoin="round"
                  />
                  <circle
                    cx={12}
                    cy={12}
                    r={3}
                    stroke="currentColor"
                    strokeWidth="1.8"
                  />
                  {showPassword && (
                    <path
                      d="M4 4l16 16"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                    />
                  )}
                </svg>
              </button>
            </div>
            {errors.password && (
              <span style={{ color: "#dc2626", fontSize: 11 }}>
                {errors.password}
              </span>
            )}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 18,
            }}
          >
            <label
              className="checkbox-row"
              style={{ fontSize: "11.5px", color: "var(--text-dim)" }}
            >
              <input type="checkbox" defaultChecked /> Remember this device
            </label>
            <span
              style={{
                fontSize: "11.5px",
                color: "var(--link)",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Forgot password?
            </span>
          </div>
          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: "100%", justifyContent: "center" }}
            disabled={loading}
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </>
  );
}
